export default "__VITE_ASSET__B77A6dri__"